import moment from 'moment';
import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { deleteHostFailed, deleteHostSuccessful } from '../actions';
import { CREATED, NO_CONTENT } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* deleteHostById(action) {
  try {
    const {
      id,
      body,
    } = action.payload;

    const url = `${BACKEND_URL}/hosts/${id}`;
    const dataResponse = yield makeRequest(url, { body }, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteHostSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteHostFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteHostFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
